<template>
    <div class="form-check js-form-validation__group" :class="sizes[size]">
        <input
            class="form-check-input"
            :id="id"
            :name="name"
            :value="value"
            v-model="model"
            :disabled="disabled"
            :type="type"
            :required="required"
        />

        <FormLabel
            v-if="label"
            :id="id"
            :label="label"
            :required="required"
            class="form-check-label"
        />

        <FormErrors />
    </div>
</template>

<script setup>
import { computed } from "vue";
import FormLabel from './Label.vue';
import FormErrors from './Errors.vue';

const props = defineProps({
    id: { type: String, required: true },
    required: { type: Boolean, default: false },
    type: { type: String, default: 'checkbox' },
    disabled: { type: Boolean, default: false },
    label: { type: String, default: '' },
    size: { type: String, default: 'default' },
    modelValue: { type: [String, Boolean], required: true },
    name: { type: String, required: true },
    value: { type: [String, Boolean], required: true },
});

const sizes = {
    default: '',
};

const emit = defineEmits(['update:modelValue', 'update:checked']);

const model = computed({
    get() {
        return props.modelValue;
    },
    set(value) {
        console.log('SET', value);
        emit("update:modelValue", value);
    },
});
</script>